import React from "react";
import { CheckIcon } from "lucide-react";
import { audiences } from "../data/landing";
export function Audience() {
  return <section className="bg-paper" data-id="element-17" data-mp="3p1nojnxcu9qd">
      <div className="mx-auto max-w-6xl px-5 py-12 md:px-8 md:py-24" data-id="element-18" data-mp="3p2p4o6t89mey">
        <div className="max-w-2xl" data-id="element-19" data-mp="6wapy5n4x8fi">
          <p className="text-sm font-semibold text-wine" data-id="element-20" data-mp="1vmriywktpb9">¿Para quién es?</p>
          <h2 className="mt-2 font-display text-[28px] leading-tight text-forest md:mt-3 md:text-5xl" data-id="element-21" data-mp="1xr2u1wt1qlk">
            Diseñado para vos si querés brillar en cada festejo del año
          </h2>
        </div>
        <ul className="mt-6 grid gap-px overflow-hidden rounded-2xl bg-line md:mt-12 sm:grid-cols-2" data-id="element-22" data-mp="brq1us1l0u9a">
          {audiences.map(a => <li key={a.title} className="flex gap-3 bg-paper p-4 md:gap-4 md:p-8" data-id="element-23" data-mp="lj3yms25ffyq">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-forest md:mt-1 md:h-7 md:w-7" data-id="element-24" data-mp="zj59n0c4o3rx">
                <CheckIcon className="h-3.5 w-3.5 text-goldSoft md:h-4 md:w-4" aria-hidden data-id="element-25" data-mp="uld95hxf39c4" />
              </span>
              <div data-id="element-26" data-mp="16ej5t6texcz4">
                <h3 className="flex flex-wrap items-center gap-2 font-display text-lg leading-tight text-forest md:text-2xl" data-id="element-27" data-mp="16f2r8xi9ujhw">
                  {a.title}
                  {a.isNew && <span className="rounded-full bg-wine px-2 py-0.5 font-sans text-[10px] font-bold tracking-wider text-paper" data-id="element-28" data-mp="1g9uog07xz4c5">
                      NUEVO
                    </span>}
                </h3>
                <p className="mt-1 text-sm leading-relaxed text-muted md:mt-2 md:text-base" data-id="element-29" data-mp="1p9zrjy63rgki">{a.text}</p>
              </div>
            </li>)}
        </ul>
        <a href="#garantia" className="mt-5 inline-block text-sm font-semibold text-wine underline decoration-wine/30 underline-offset-4 transition-colors duration-150 hover:decoration-wine md:mt-8" data-id="element-30" data-mp="1z25mngrnie3x">
          ¿No estás segura si es para vos? Tenés 7 días de garantía →
        </a>
      </div>
    </section>;
}